// extracted by mini-css-extract-plugin
export default {"quantity_container":"xB","hiddenflavorstring":"yB","loadingLine":"zB","productimgwrap":"AB","productimg":"BB","circlepic":"CB","productinfo":"EB","grey_x":"FB","cartrow":"GB","bold":"HB","title":"IB","blue":"JB","strike":"KB","flexgap":"LB","flavorstring":"MB","nodecorate":"NB","flavorstring_link":"OB","rdstring":"PB","removeditemblock":"QB","removed_heading":"RB","removed_text":"SB","addback":"TB"};
    if(module.hot) {
      // 1715188236258
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  